var _g, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudienceTargeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 92,
    viewBox: "0 0 70 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5330_4129)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.90836,
    y: 0.532383,
    width: 51.0657,
    height: 82.089,
    rx: 3.64227,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 70.5254,
    width: 46.6524,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 73.4512,
    width: 43.7366,
    height: 1.95042,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.85352,
    y: 76.376,
    width: 9.71924,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1185 14.7406C12.1185 16.9875 10.3033 18.8082 8.06519 18.8082C5.82711 18.8082 4.01188 16.9875 4.01188 14.7406C4.01188 12.4936 5.82711 10.673 8.06519 10.673C10.3033 10.673 12.1185 12.4936 12.1185 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint0_linear_5330_4129)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8079 14.7406C21.8079 16.9875 19.9927 18.8082 17.7546 18.8082C15.5166 18.8082 13.7013 16.9875 13.7013 14.7406C13.7013 12.4936 15.5166 10.673 17.7546 10.673C19.9927 10.673 21.8079 12.4936 21.8079 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint1_linear_5330_4129)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4935 14.7406C31.4935 16.9875 29.6783 18.8082 27.4402 18.8082C25.2021 18.8082 23.3869 16.9875 23.3869 14.7406C23.3869 12.4936 25.2021 10.673 27.4402 10.673C29.6783 10.673 31.4935 12.4936 31.4935 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint2_linear_5330_4129)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.181 14.7406C41.181 16.9875 39.3658 18.8082 37.1277 18.8082C34.8896 18.8082 33.0744 16.9875 33.0744 14.7406C33.0744 12.4936 34.8896 10.673 37.1277 10.673C39.3658 10.673 41.181 12.4936 41.181 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint3_linear_5330_4129)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8685 14.7406C50.8685 16.9875 49.0533 18.8082 46.8152 18.8082C44.5771 18.8082 42.7619 16.9875 42.7619 14.7406C42.7619 12.4936 44.5771 10.673 46.8152 10.673C49.0533 10.673 50.8685 12.4936 50.8685 14.7406Z",
    fill: "#E5E5E5",
    stroke: "url(#paint4_linear_5330_4129)",
    strokeWidth: 0.316719
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.69531,
    y: 21.1787,
    width: 47.6243,
    height: 47.7856,
    rx: 0.633439,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.96289,
    y: 3.33203,
    width: 20.0864,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.96289,
    y: 6.25879,
    width: 9.07129,
    height: 1.95043,
    rx: 0.633439,
    fill: "#E5E5E5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2097,
    cy: 70.5056,
    r: 21.0398,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5708 69.6624C52.2366 69.6624 52.8875 69.465 53.4411 69.0951C53.9947 68.7252 54.4261 68.1994 54.6809 67.5843C54.9357 66.9692 55.0024 66.2923 54.8725 65.6393C54.7426 64.9863 54.422 64.3865 53.9512 63.9157C53.4804 63.4449 52.8806 63.1243 52.2276 62.9944C51.5746 62.8645 50.8977 62.9311 50.2826 63.1859C49.6674 63.4407 49.1417 63.8722 48.7718 64.4258C48.4019 64.9794 48.2045 65.6302 48.2045 66.2961C48.2045 67.1889 48.5591 68.0451 49.1904 68.6764C49.8218 69.3077 50.678 69.6624 51.5708 69.6624ZM56.6204 78.0783C56.8436 78.0783 57.0576 77.9896 57.2155 77.8318C57.3733 77.674 57.462 77.4599 57.462 77.2367C57.462 75.6743 56.8413 74.1759 55.7365 73.0711C54.6317 71.9663 53.1332 71.3456 51.5708 71.3456C50.0084 71.3456 48.51 71.9663 47.4052 73.0711C46.3004 74.1759 45.6797 75.6743 45.6797 77.2367C45.6797 77.4599 45.7684 77.674 45.9262 77.8318C46.084 77.9896 46.2981 78.0783 46.5213 78.0783H56.6204Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.69 69.6624C46.3558 69.6624 47.0066 69.465 47.5602 69.0951C48.1138 68.7252 48.5453 68.1994 48.8001 67.5843C49.0549 66.9692 49.1215 66.2923 48.9916 65.6393C48.8617 64.9863 48.5411 64.3865 48.0703 63.9157C47.5995 63.4449 46.9997 63.1243 46.3467 62.9944C45.6937 62.8645 45.0168 62.9311 44.4017 63.1859C43.7866 63.4407 43.2608 63.8722 42.8909 64.4258C42.521 64.9794 42.3236 65.6302 42.3236 66.2961C42.3236 67.1889 42.6783 68.0451 43.3096 68.6764C43.9409 69.3077 44.7971 69.6624 45.69 69.6624ZM50.7395 78.0783C50.9627 78.0783 51.1768 77.9896 51.3346 77.8318C51.4924 77.674 51.5811 77.4599 51.5811 77.2367C51.5811 75.6743 50.9604 74.1759 49.8556 73.0711C48.7508 71.9663 47.2524 71.3456 45.69 71.3456C44.1275 71.3456 42.6291 71.9663 41.5243 73.0711C40.4195 74.1759 39.7988 75.6743 39.7988 77.2367C39.7988 77.4599 39.8875 77.674 40.0453 77.8318C40.2032 77.9896 40.4172 78.0783 40.6404 78.0783H50.7395Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5330_4129",
    x: 0.166403,
    y: 0.374023,
    width: 57.7172,
    height: 88.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5836,
    dy: 3.16719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5836
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5330_4129"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5330_4129",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5330_4129",
    x1: 8.06519,
    y1: 10.5146,
    x2: 8.06519,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5330_4129",
    x1: 17.7546,
    y1: 10.5146,
    x2: 17.7546,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5330_4129",
    x1: 27.4402,
    y1: 10.5146,
    x2: 27.4402,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5330_4129",
    x1: 37.1277,
    y1: 10.5146,
    x2: 37.1277,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5330_4129",
    x1: 46.8152,
    y1: 10.5146,
    x2: 46.8152,
    y2: 18.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD703"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceTargeting);
export default __webpack_public_path__ + "static/media/audienceTargeting.f817e928be76d73c61452d70d7a7793e.svg";
export { ForwardRef as ReactComponent };